const PatientsStore = {
	data: {
		patients: [
			{
				id: 1,
				filterStatus: true,
				firstName: 'Madonna',
				lastName: 'Abernathy',
				phn: '8375-640-244',
				province: 'BC'
			},
			{
				id: 7,
				filterStatus: true,
				firstName: 'Wendy',
				lastName: 'Zhou',
				phn: '9830-768-122',
				province: 'BC'
			},
			{
				id: 2,
				filterStatus: true,
				firstName: 'Constance',
				lastName: 'Benjamin',
				phn: '8563-572-967',
				province: 'BC'
			},
			{
				id: 3,
				filterStatus: true,
				firstName: 'Mustafa',
				lastName: 'Benzema',
				phn: '3966-285-778',
				province: 'BC'
			},
			{
				id: 4,
				filterStatus: true,
				firstName: 'Peter',
				lastName: 'Davis',
				phn: '3956-694-089',
				province: 'BC'
			},
			{
				id: 5,
				filterStatus: true,
				firstName: 'Chrissy',
				lastName: 'Lightfoot',
				phn: '8231-597-555',
				province: 'BC'
			},
			{
				id: 6,
				filterStatus: true,
				firstName: 'Chang',
				lastName: 'Xiang',
				phn: '8576-999-889',
				province: 'BC'
			},
			{
				id: 8,
				filterStatus: true,
				firstName: 'Amy',
				lastName: 'Smith',
				phn: '8987-987-98',
				province: 'BC'
			},
			{
				id: 9,
				filterStatus: true,
				firstName: 'Amos',
				lastName: 'Roberts',
				phn: '8615-013-076',
				province: 'BC'
			},
			{
				id: 10,
				filterStatus: true,
				firstName: 'Marlen',
				lastName: 'Upton',
				phn: '3708-555-357',
				province: 'BC'
			},
			{
				id: 11,
				filterStatus: true,
				firstName: 'Delphine',
				lastName: 'Kihn',
				phn: '2086-219-802',
				province: 'BC'
			},
			{
				id: 12,
				filterStatus: true,
				firstName: 'Lolita',
				lastName: 'Roob',
				phn: '3235-790-710',
				province: 'BC'
			},
			{
				id: 13,
				filterStatus: true,
				firstName: 'Ericka',
				lastName: 'Pagac',
				phn: '5059-476-261',
				province: 'BC'
			},
			{
				id: 14,
				filterStatus: true,
				firstName: 'Carlee',
				lastName: 'Crooks',
				phn: '5435-582-546',
				province: 'BC'
			},
			{
				id: 15,
				filterStatus: true,
				firstName: 'Emiliano',
				lastName: 'Kreiger',
				phn: '7472-599-410',
				province: 'BC'
			},
			{
				id: 16,
				filterStatus: true,
				firstName: 'Coralie',
				lastName: 'Orn',
				phn: '4092-386-072',
				province: 'BC'
			},
			{
				id: 17,
				filterStatus: true,
				firstName: 'Columbus',
				lastName: 'Kutch',
				phn: '9432-352-384',
				province: 'BC'
			},
			{
				id: 18,
				filterStatus: true,
				firstName: 'Keira',
				lastName: 'Rohan',
				phn: '8291-002-639',
				province: 'BC'
			},
			{
				id: 19,
				filterStatus: true,
				firstName: 'Blake',
				lastName: 'Trutel',
				phn: '8203-864-657',
				province: 'BC'
			},
			{
				id: 20,
				filterStatus: true,
				firstName: 'Lera',
				lastName: 'Crist',
				phn: '5787-216-126 ',
				province: 'BC'
			},
			{
				id: 21,
				filterStatus: true,
				firstName: 'Bryce',
				lastName: 'Mertz',
				phn: '9340-372-261',
				province: 'BC'
			},
			{
				id: 22,
				filterStatus: true,
				firstName: 'Juwan',
				lastName: 'Lemke',
				phn: '2263-274-396',
				province: 'BC'
			},
			{
				id: 23,
				filterStatus: true,
				firstName: 'Roberto',
				lastName: 'Gonzalez',
				phn: '7767-321-111',
				province: 'BC'
			},
			{
				id: 24,
				filterStatus: true,
				firstName: 'Nick',
				lastName: 'Xenophon',
				phn: '8890-743-443',
				province: 'BC'
			},
		]
	},
	methods: {
		getPatientObject($id) {
			let $index = PatientsStore.data.patients.findIndex(
				element => element.id == $id
			);
			return PatientsStore.data.patients[$index];
		},
		setStatus($id, $status) {
			let $index = PatientsStore.data.patients.findIndex(
				element => element.id == $id
			);
			PatientsStore.data.patients[$index].filterStatus = $status;
		},
	}
};

export default PatientsStore;